module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlklEQVQ4T+2TWxHCQAxFz3VQCTgoEooA0NA6qIRKWAfUAkUAlVAcIAEHl9nZmWX5LPDZfJ4kN49JxI8m2ksA1V/qLKKbDNyB51vEe9CjYBV4B1qKQhVQJwHrwHics7ObZqwhs/baIA+cT02OSez2LwH3qGjPDsCYmeNItEh97iAyKWw72HaQ7iA+kxQPZb3Zi9ZnfWa8AFhWtivlSXaxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imges/4.png
// module id = YO7v
// module chunks = 115